import React from "react";
import { intl } from "LocaleWrapper";
import { Box, IconButton, Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import usePopover from "components/hooks/usePopover";
import { LocationLink } from "utils/LinkUtils";
import { LocationGroupFragment } from "__generated__/view/locations/graphql/location.fragments.generated";

const LocationGroupsPopover = ({ locationGroups }: { locationGroups: LocationGroupFragment[] }) => {

	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (locationGroups.length === 1) {
		return (
			<React.Fragment>
				<LocationLink location={locationGroups[0]} />
			</React.Fragment>
		);
	} else if (locationGroups.length > 1) {
		return (
			<React.Fragment>
				<span style={{ alignItems: "center", display: "flex" }}>

					{`${locationGroups.length} ${intl.formatMessage({ id: "LOCATIONS" })}`}

					<IconButton onClick={(event) => onPopoverOpen(event)} size="small">
						<InfoOutlinedIcon fontSize="small" />
					</IconButton>
				</span>

				<Popover {...popoverProps}>
					<Box p={2}>
						{locationGroups.map((location, index) => (
							<div key={index}>
								<LocationLink location={location} />
							</div>
						))}
					</Box>
				</Popover>
			</React.Fragment>
		);
	} else {
		return <React.Fragment />;
	}
};

export default LocationGroupsPopover;
